module.exports = __webpack_public_path__ + "static/media/eczane.60af7adb.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/labs/eczane.png
// module id = 125
// module chunks = 0